import {
  IconClock,
  IconHourglass,
  IconX,
  IconChecks,
} from "@tabler/icons-react"
import { CertificateStatus } from "@tfg/db"
import { BadgeVariant, StatusBadge } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type Props = {
  status: CertificateStatus | null
}

export function CertificateStatusBadge({ status }: Props) {
  const certificateStatusDetails = useGetCertificateStatus(status)
  if (!certificateStatusDetails) return null
  return (
    <StatusBadge
      text={certificateStatusDetails.translation}
      icon={certificateStatusDetails.icon}
      variant={certificateStatusDetails.variant}
      iconSize={14}
    />
  )
}

function useGetCertificateStatus(status: CertificateStatus | null) {
  const { t } = useTranslation("certificates")

  switch (status) {
    case CertificateStatus.PENDING:
      return {
        variant: BadgeVariant.INFO,
        icon: <IconClock size={16} />,
        translation: t(`certificateStatus.PENDING`),
      }
    case CertificateStatus.PROCESSED:
      return {
        variant: BadgeVariant.SUCCESS,
        icon: <IconChecks size={12} />,
        translation: t(`certificateStatus.PROCESSED`),
      }
    case CertificateStatus.REJECTED:
      return {
        variant: BadgeVariant.ERROR,
        icon: <IconX size={16} />,
        translation: t(`certificateStatus.REJECTED`),
      }
    case CertificateStatus.NOT_UPLOADED:
      return {
        variant: BadgeVariant.INFO,
        icon: <IconHourglass size={16} />,
        translation: t(`certificateStatus.NOT_UPLOADED`),
      }
    default:
      return null
  }
}
